import { Card, Stack, Typography } from '@mui/material';
import { ProjectProps } from 'src/@types/project';
import { TextIconLabel, Iconify } from 'src/components';
import enterpriseIcon from '@iconify/icons-carbon/enterprise';
import userIcon from '@iconify/icons-carbon/user';
import locationIcon from '@iconify/icons-carbon/location';

type Props = {
  project: ProjectProps;
};

const ProjectInfo: React.FC<Props> = ({ project }) => {
  const { builder, builderURL, manager, location } = project;

  return (
    <Card sx={{ p: 3 }}>
      <Stack spacing={2}>
        <TextIconLabel
          spacing={2}
          alignItems="flex-start"
          icon={<Iconify icon={locationIcon} sx={{ width: 24, height: 24 }} />}
          value={
            <Stack>
              <Typography variant="subtitle2"> Lokasjon </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {location}
              </Typography>
            </Stack>
          }
        />
        <TextIconLabel
          spacing={2}
          alignItems="flex-start"
          icon={<Iconify icon={userIcon} sx={{ width: 24, height: 24 }} />}
          value={
            <Stack>
              <Typography variant="subtitle2"> Prosjektleder </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {manager}
              </Typography>
            </Stack>
          }
        />
        <TextIconLabel
          spacing={2}
          alignItems="flex-start"
          icon={<Iconify icon={enterpriseIcon} sx={{ width: 24, height: 24 }} />}
          value={
            <Stack>
              <Typography variant="subtitle2"> Byggherre </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {builder}
              </Typography>
            </Stack>
          }
        />
      </Stack>
    </Card>
  );
};

export default ProjectInfo;
